export function VideoPlayer() {

    const $VIDEO = document.querySelector('.video'),
        $VIDEO_CONTAINER = document.querySelector('.video-container'),
        $VIDEO_CONTROLS = document.querySelector('.video-controls'),
        $BUTTON_PAUSE_AND_PLAY = document.querySelectorAll('.play-and-pause-video'),
        $PROGRESS_VIDEO = document.querySelector('.progress-video'),
        $CHANGE_VOLUME = document.querySelector('.volume-video'),
        $FULLSCREEN = document.querySelector('.fullscreen-video'),
        $BLUR = document.querySelector('.video-blur');

    function durationVideo() {
        let durationMidia = $VIDEO.duration,
            $durationTime = document.querySelector('.duration-time');
        $durationTime.innerHTML = transformVideoDuration(durationMidia);
    };

    function progressVideo() {
        var autoProgress = $VIDEO.currentTime,
            $progressBar = document.querySelector('.progress-video'),
            $progressTime = document.querySelector('.progress-time');
        $progressBar.value = autoProgress.toFixed(0);
        $progressBar.setAttribute('max', $VIDEO.duration);
        $progressTime.innerHTML = transformVideoDuration(autoProgress);
        animationProgress();
    };

    function ChangeProgressVideo() {
        const $changeProgress = document.querySelector('.progress-video');
        $VIDEO.currentTime = $changeProgress.value;
    };

    function animationProgress() {
        let percentageProgress = (($PROGRESS_VIDEO.value - $PROGRESS_VIDEO.min) * 100) / ($PROGRESS_VIDEO.max - $PROGRESS_VIDEO.min);
        $PROGRESS_VIDEO.style.backgroundSize = `${percentageProgress}% 100%`;
        //console.log('progress: ' + percentageProgress)
    };

    function transformVideoDuration(timeVideo) {
        let hours, mins, secds, time;
        hours = Math.floor(timeVideo / 3600);
        mins = Math.floor(timeVideo / 60);
        secds = Math.floor(timeVideo - mins * 60)
        return time = formartTimeVideo(hours, mins, secds);
    };

    function formartTimeVideo(hours, mins, secds) {
        let time;
        if (hours < 1) {
            hours = '';
        };
        if (hours < 10 && hours != '') {
            hours = '0' + hours + ':';
        };
        if (mins < 10) {
            mins = '0' + mins;
        }
        if (secds < 10) {
            secds = '0' + secds;
        }
        return time = `${hours}${mins}:${secds}`;
    };

    function playAndPause() {
        let $playButton = document.querySelectorAll('.play-and-pause-video');
        if ($VIDEO.paused == true) {
            playVideo();
            $playButton.forEach(changePlayButton => {
                changePlayButton.classList.remove('fa-play');
                changePlayButton.classList.add('fa-pause');
            });
            $BLUR.style.opacity = "0";
        } else {
            pauseVideo();
            $playButton.forEach(changePlayButton => {
                changePlayButton.classList.remove('fa-pause');
                changePlayButton.classList.add('fa-play');
            });
            $BLUR.style.opacity = "1";
        }
    };

    function pauseVideo(){
        $VIDEO.pause();
    };

    function playVideo(){
        $VIDEO.play();
    };

    function muteVideo(){
        $VIDEO.volume = 0
    };

    function unmuteVideo(){
        $VIDEO.volume = 1;
    };

    function volume() {
        let $buttonVolume = document.querySelector('.volume-video');
        if ($VIDEO.volume === 0) {
            unmuteVideo();
            $buttonVolume.classList.add('fa-volume-up');
            $buttonVolume.classList.remove('fa-volume-off');
        } else {
            muteVideo();
            $buttonVolume.classList.add('fa-volume-off');
            $buttonVolume.classList.remove('fa-volume-up');
        };
    };

    function endVideo(){
        let $playButtonEnd = document.querySelectorAll('.play-and-pause-video');
        $VIDEO_CONTROLS.classList.remove('video-controls-visibility--hidden');
        $playButtonEnd.forEach(changePlayButton => {
            changePlayButton.classList.remove('fa-pause');
            changePlayButton.classList.add('fa-play');
        });
        $VIDEO.volume = 1;
        $BLUR.style.opacity = "1";
    }

    function videoFullScreen() {
        let divwrapper = document.querySelector('.video-container');
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement ) {
            if ($VIDEO.requestFullscreen) {
                divwrapper.requestFullscreen().catch(e => console.log(e));
            } else if ($VIDEO.msRequestFullscreen) {
                divwrapper.msRequestFullscreen();
            } else if ($VIDEO.mozRequestFullScreen) {
                divwrapper.mozRequestFullScreen();
            } else if ($VIDEO.webkitRequestFullscreen) {
                divwrapper.webkitRequestFullscreen();
            }
            $FULLSCREEN.classList.remove('fa-expand');
            $FULLSCREEN.classList.add('fa-compress');
            $VIDEO_CONTAINER.classList.add('fullscreen');
            console.log('enter fullscreen');
        } else {
            console.log('exit fullscreen');
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
            $FULLSCREEN.classList.remove('fa-compress');
            $FULLSCREEN.classList.add('fa-expand');
            $VIDEO_CONTAINER.classList.remove('fullscreen');
        };
    };

    function exitFullscreenPerKey() {
        if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
            console.log('exit fullscreen via esc');
            $FULLSCREEN.classList.remove('fa-compress');
            $FULLSCREEN.classList.add('fa-expand');
            $VIDEO_CONTAINER.classList.remove('fullscreen');
        }
    }

    function controlVisibility(){
        setTimeout(function(){
            $VIDEO_CONTROLS.classList.remove('video-controls-visibility--visible');
            $VIDEO_CONTROLS.classList.add('video-controls-visibility--hidden');
        }, 10000)
        //console.log('play')
    };


//               EVENTS PLAYER

    if ($VIDEO) {

        console.log('player is available');
        // EVENTS VIDEO
        $VIDEO.addEventListener('loadeddata', durationVideo);

        $VIDEO.addEventListener('timeupdate', progressVideo);

        $VIDEO.addEventListener('play', controlVisibility);

        $VIDEO.addEventListener('ended', endVideo);

// EVENTS VIDEO CONTROLS

        $PROGRESS_VIDEO.addEventListener('change', ChangeProgressVideo)

        $BUTTON_PAUSE_AND_PLAY.forEach(buttonPauseAndPlay => {
            buttonPauseAndPlay.addEventListener('click', playAndPause);
        });

        $CHANGE_VOLUME.addEventListener('click', volume);

        $FULLSCREEN.addEventListener('click', videoFullScreen);

        let $FULLSCREENCHANGEEVENTS = ['fullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'];

        $FULLSCREENCHANGEEVENTS.forEach(fullScreenChangeEvent => {
            document.addEventListener(fullScreenChangeEvent, exitFullscreenPerKey, false);
        });
    }
}


